<template>
    <md-list-item>
        <div class="input">
            <md-checkbox v-model="array" :value="userName" :disabled="isCheckDisabled"/>
        </div>
        <md-avatar>
            <img :src="userIcon" alt="ユーザアイコン">
        </md-avatar>
        <span class="md-list-item-text">{{userName}}</span>
    </md-list-item>
</template>

<script>

    export default {
        name: "UserComponent",
        props: {
            userName: String,
            userIcon: String,
            array: Array,
        },
        data: function () {
            return {
            }
        },
        methods: {
        },
        computed: {
            isCheckDisabled() {
                return this.array.length >= 5 && this.array.indexOf(this.userName) === -1 ? "disabled" : null
            }
        },
    }
</script>

<style scoped>
</style>
